import { Route } from 'lucide-react';

import { numberFormat } from '../../pages/weeklyreport/format';
import { type weeklyReportTopRoute } from '../../services/api/weekly-report';

export const TopRoutes = ({ routes }: { routes: weeklyReportTopRoute[] }) => {
  if (routes.length === 0) {
    return <p className="text-sm text-slate-500">Ingen route-data denna vecka.</p>;
  }

  return (
    <ul className="space-y-1">
      {routes.map((route) => (
        <li
          key={route.route}
          className="flex items-center justify-between gap-3 border-b border-slate-100 py-2 last:border-0"
        >
          <span className="flex min-w-0 items-center gap-2">
            <Route className="h-4 w-4 shrink-0 text-slate-400" />
            <span className="truncate font-mono text-sm text-slate-700">{route.route}</span>
            {route.failCount > 0 && (
              <span className="shrink-0 rounded bg-red-50 px-1.5 py-0.5 text-xs text-red-600">
                {numberFormat.format(route.failCount)} fel
              </span>
            )}
          </span>
          <span className="font-medium">{numberFormat.format(route.runCount)}</span>
        </li>
      ))}
    </ul>
  );
};
